import { useMemo } from "react";
import type { UserSerialize } from "@/types/auth";
import type { Auth } from "@/types/globals";

export interface UseAuthProps {
	auth: Auth;
	user: UserSerialize;
}

export const useAuth = ({ user, auth }: UseAuthProps) => {
	const isAuthCurrentUser = useMemo(
		() => user.email === auth.currentUser?.user.email,
		[user.email, auth.currentUser?.user.email],
	);
	const isAuthSuperAdmin = useMemo(
		() => auth.currentUser?.["isSuperAdmin?"],
		[auth.currentUser?.["isSuperAdmin?"]],
	);
	const isAuthAdminSupervisor = useMemo(
		() => auth.currentUser?.["isAdminSupervisor?"],
		[auth.currentUser?.["isAdminSupervisor?"]],
	);

	return {
		isAuthCurrentUser,
		isAuthSuperAdmin,
		isAuthAdminSupervisor,
	};
};
